export default __webpack_public_path__ + "static/media/BasicProgramming3.b934383a.png";